// @ts-nocheck

import React, { forwardRef, useEffect, useRef } from 'react';
import { register } from 'swiper/element/bundle';

register();

export const SwiperCarousel = forwardRef<HTMLElement, any>((props, refFromParent) => {
  const fallbackRef = useRef<HTMLElement | null>(null);
  const elRef = (refFromParent as React.RefObject<HTMLElement>) ?? fallbackRef;

  const { children, ...rest } = props;

  useEffect(() => {
    const el = elRef.current;
    if (!el) return;
    Object.assign(el, rest);
    el.initialize();
  }, []);

  return (
    <swiper-container init="false" ref={elRef}>
      {children}
    </swiper-container>
  );
});
SwiperCarousel.displayName = 'SwiperCarousel';

export const SwiperSlide = ({ children, ...rest }) => (
  <swiper-slide {...rest}>{children}</swiper-slide>
);